export const makeRoute = (
  path: string,
  element: React.ReactNode,
  layout: React.ReactNode,
  errorElement?: React.ReactNode
) => ({
  path,
  element: layout,
  ...(errorElement && { errorElement }),
  children: [
    {
      index: true,
      element,
    },
  ],
});

export default makeRoute;

